import { BaseElement } from './base-element';
import { ChartType } from './chart-type';
import { ElementType } from './element-type';

export class Chart extends BaseElement {
  data: any[];
  chartType: ChartType = 0;
  legend: boolean = false;
  showXAxisLabel: boolean = false;
  showYAxisLabel: boolean = false;

  legendTitle: string = '';
  xAxisLabel: string = '';
  yAxisLabel: string = '';

  height: number = 280;

  constructor(data: any[]) {
    super();
    this.elementType = ElementType.chart;
    this.data = data;
  }
}
